import { render, staticRenderFns } from "./MemberIcon.vue?vue&type=template&id=4049ecd6"
import script from "./MemberIcon.vue?vue&type=script&lang=ts"
export * from "./MemberIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports